import Partnership from "./partnership";

export default Partnership;
